import { render, staticRenderFns } from "./BusinessDaily.vue?vue&type=template&id=47983d3c&"
import script from "./BusinessDaily.vue?vue&type=script&lang=js&"
export * from "./BusinessDaily.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDaily.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports